<template>
  <v-container fluid>
    <v-row justify="left" align="start">
      <v-col cols="6" class="hide">
        <v-card
            class="mx-auto rounded-lg"
            outlined
        >
          <v-list-item three-line>
            <v-list-item-content>
              <div class="font-weight-bold text-decoration-underline mb-4">
                Tin tức
              </div>
              <v-row>
                <v-col cols="10">
                  <v-autocomplete
                      background-color="#EDF2F7"
                      filled
                      :items="list_post"
                      item-text="name"
                      item-value="id"
                      v-model="highlight_post_id"
                      label="Chọn bài viết highlight"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">Danh sách bài viết
                  <v-btn icon @click="addBlockPost">
                    <v-icon color="primary">mdi-plus-box</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-row class="pa-0 ma-0" v-for="(item, index) in post_ids" :key="index">
                    <v-col cols="10" class="ma-0 pa-0">
                      <v-autocomplete
                          background-color="#EDF2F7"
                          filled
                          :items="list_post"
                          item-text="name"
                          item-value="id"
                          v-model="item.post_id"
                          label="Chọn bài viết"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" class="ma-0 pa-0">
                      <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearBlockPost(index)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card
            class="mx-auto rounded-lg"
            outlined
        >
          <v-list-item three-line>
            <v-list-item-content>
              <div class="font-weight-bold text-decoration-underline mb-4">
                Video
              </div>
              <v-row>
                <v-col cols="10">
                  <v-autocomplete
                      background-color="#EDF2F7"
                      filled
                      :items="list_video"
                      item-text="name"
                      item-value="id"
                      v-model="highlight_video_id"
                      label="Chọn video highlight"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">Danh sách video
                  <v-btn icon @click="addBlockVideo">
                    <v-icon color="primary">mdi-plus-box</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12">
                  <v-row class="pa-0 ma-0" v-for="(item, index) in video_ids" :key="index">
                    <v-col cols="10" class="ma-0 pa-0">
                      <v-autocomplete
                          background-color="#EDF2F7"
                          filled
                          :items="list_video"
                          item-text="name"
                          item-value="id"
                          v-model="item.post_id"
                          label="Chọn bài viết"
                      ></v-autocomplete>
                    </v-col>
                    <v-col cols="2" class="ma-0 pa-0">
                      <v-btn
                          class="ma-2"
                          outlined
                          large
                          color="indigo"
                          @click="clearBlockVideo(index)"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn
            color="primary"
            width="180"
            @click="save()"
        >
          Lưu
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex'
import {GET_LIST_NEWS} from '@/store/modules/news'
import {GET_POST_CONFIGS, UPDATE_POST_CONFIGS} from '@/store/modules/configs'
export default {
  data() {
    return {
      highlight_post_id:null,
      highlight_video_id:null,
      list_post: [],
      list_video: [],
      post_ids: [],
      video_ids: [],
      items: [
        {
          id: 1,
          text: 'item 1',
        },
        {
          id: 2,
          text: 'item 2',
        },
        {
          id: 3,
          text: 'item 3',
        },
      ],
    };
  },
  watch:{
    news(val) {
      const _this = this;
      if (val && val.length > 0) {
        val.forEach(el => {
          if (el.type == 1) {
            _this.list_post.push(el)
          }
          if (el.type == 2) {
            _this.list_video.push(el)
          }
        })
      }
    },
    post_config(val) {
      const _this = this;
      if (val) {
        this.highlight_post_id = parseInt(val.highlight_post_id);
        this.highlight_video_id = parseInt(val.highlight_video_id);
        if (val.post_ids) {
          _this.post_ids = [];
          val.post_ids.forEach(el => {
            _this.post_ids.push(el)
          })
        }
        if (val.video_ids) {
          _this.video_ids = [];
          val.video_ids.forEach(el => {
            _this.video_ids.push(el)
          })
        }
      }
    }
  },
  computed:{
    ...mapGetters({
      news: 'news',
      post_config: 'post_config',
    })
  },
  async created(){
    await this.$store.dispatch(`${GET_LIST_NEWS}`);
    await this.$store.dispatch(`${GET_POST_CONFIGS}`);
  },
  methods:{
    async save(){
      let data = {
        highlight_post_id: this.highlight_post_id,
        highlight_video_id: this.highlight_video_id,
        post_ids: JSON.stringify(this.post_ids),
        video_ids: JSON.stringify(this.video_ids),
      }
      await this.$store.dispatch(`${UPDATE_POST_CONFIGS}`, data).then((data)=>{
        if (data) {
          this.$toasted.success('Cập nhật thành công!', {
            duration:1000,
            position:'top-center'
          });
        } else {
          this.$toasted.error('Cập nhật không thành công!', {
            duration:1000,
            position:'top-center'
          });
        }
      });
    },
    addBlockPost() {
      this.post_ids.push({
        post_id: null,
      })
    },
    clearBlockPost(index){
      this.post_ids.splice(index, 1)
      this.$forceUpdate()
    },
    addBlockVideo() {
      this.video_ids.push({
        post_id: null,
      })
    },
    clearBlockVideo(index){
      this.video_ids.splice(index, 1)
      this.$forceUpdate()
    }
  }
};
</script>
